document.addEventListener('DOMContentLoaded', () => {
    const navigators = document.getElementsByClassName('menu__item');
    var url = window.location.href;
    if (url.indexOf("collections") !== -1 || url.indexOf("products") !== -1) {
        navigators[0].children[0].children[0].style.color = 'var(--link-hover)';
    }
    if (url.indexOf("pages") !== -1) {
        if(url.indexOf("private-product-list") !== -1) {
            navigators[0].children[0].children[0].style.color = 'var(--link-hover)';
        } else if(url.indexOf("12-days-december") !== -1 && url.indexOf("view=glp1_educational2") !== -1) {
            navigators[1].children[0].children[0].style.color = '#ffffff';
            // Replace logo for GLP1 educational page
            const logoContainer = document.querySelector('.header__logo__container');
            if (logoContainer) {
                const logoImg = logoContainer.querySelector('img');
                console.log(logoImg);
                if (logoImg) {
                    logoImg.src = '//zenwise.com/cdn/shop/t/600/assets/Zen_White.png?v=184374496773163341491746202041';
                    logoImg.dataset.src = '//zenwise.com/cdn/shop/t/600/assets/Zen_White.png?v=184374496773163341491746202041';
                }
            }
        } else {
            navigators[1].children[0].children[0].style.color = 'var(--link-hover)';
        }
    }
    if (url.indexOf("blogs") !== -1) {
        navigators[2].children[0].children[0].style.color = 'var(--link-hover)';
    }
});